const SET_CHARACTER_LIST = (
  state,
  { characterList, totalCount, totalPageCount, pageNo, pageSize }
) => {
  state.characterList = characterList
  state.totalCount = totalCount
  state.totalPageCount = totalPageCount
  state.pageNo = pageNo
  state.pageSize = pageSize
}

const SET_SELECTED_CHARACTER = (state, { selectedCharacter }) => {
  state.selectedCharacter = selectedCharacter
}

const SET_SORT_TYPE = (state, { sortType }) => {
  state.sortType = sortType
}

export default {
  SET_CHARACTER_LIST,
  SET_SELECTED_CHARACTER,
  SET_SORT_TYPE
}
